// Toggle this to inject the simulation round instead of real spin data
export const DEV_SIMULATION_ENABLED = false;

export const DEV_SIMULATION_ROUND = {
  bet: 100,
  win: 500,
  wins: [
    {
      symbol: 1,
      win: 200,
      positions: [
        [0, 1],
        [1, 1],
        [2, 1],
        [3, 1],
      ],
      id: 1,
      line: [1, 1, 1, 1, 2],
      isScatter: false,
    },
    {
      symbol: 1,
      win: 150,
      positions: [
        [0, 2],
        [1, 2],
        [2, 2],
        [3, 2],
      ],
      id: 2,
      line: [2, 2, 2, 2, 3],
      isScatter: false,
    },
    {
      symbol: 1,
      win: 150,
      positions: [
        [0, 0],
        [1, 0],
        [2, 0],
        [3, 0],
      ],
      id: 3,
      line: [0, 0, 0, 0, 1],
      isScatter: false,
    },
    {
      symbol: 9,
      win: 50,
      positions: [
        [0, 3],
        [2, 3],
        [4, 3],
      ],
      id: null,
      isScatter: true,
    },
  ],
  reels: [
    [1, 1, 1, 9],
    [1, 1, 1, 6],
    [1, 1, 1, 10],
    [1, 1, 1, 4],
    [3, 4, 5, 9],
  ],
  type: "regular",
  id: `test-h1-wins-${Date.now()}`,
  winType: "regular_win",
  isAnimatedWin: false,
  scatterCount: 3,
};
